import script from "./CookieBar.vue?vue&type=script&setup=true&lang=js"
export * from "./CookieBar.vue?vue&type=script&setup=true&lang=js"

import "./CookieBar.vue?vue&type=style&index=0&id=666a24fb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-666a24fb"]])

export default __exports__